export const getJobTitleInitials = (company: string): string => {
  if (!company) return "JD";
  const words = company.trim().split(/\s+/);
  if (words.length >= 2) {
    return (words[0][0] + words[1][0]).toUpperCase();
  }
  return company.substring(0, 2).toUpperCase();
};
